import {
	queryOptions,
	useQuery,
	useQueryClient,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchStations, searchStations, type StationSearchParams } from "./services";

export const stationKeys = {
	all: ["stations"] as const,
	list: () => [...stationKeys.all, "list"] as const,
	search: (params: StationSearchParams) =>
		[...stationKeys.all, "search", params] as const,
};

export function stationsQueryOptions() {
	return queryOptions({
		queryKey: stationKeys.list(),
		queryFn: fetchStations,
		staleTime: 30_000,
	});
}

export function useStationsQuery() {
	return useSuspenseQuery(stationsQueryOptions());
}

// Non-suspense version for components that don't need Suspense behavior
export function useStationsQueryAsync() {
	return useQuery(stationsQueryOptions());
}

export function stationSearchOptions(params: StationSearchParams) {
	return queryOptions({
		queryKey: stationKeys.search(params),
		queryFn: () => searchStations(params),
		staleTime: 30_000,
	});
}

export function useSearchStationsQuery(params: StationSearchParams) {
	return useSuspenseQuery(stationSearchOptions(params));
}

// Non-suspense version for components that don't need Suspense behavior
export function useSearchStationsQueryAsync(params: StationSearchParams) {
	return useQuery(stationSearchOptions(params));
}

export function usePrefetchStationsQuery(params: StationSearchParams) {
	const queryClient = useQueryClient();

	useEffect(() => {
		queryClient.prefetchQuery(stationSearchOptions(params));
	}, [queryClient, params.search, params.limit]);
}
